import type { AcademicArticleDownloadPayload } from '~/types/download'

export function isAcademicArticlePayload(payload: unknown): payload is AcademicArticleDownloadPayload {
  return Boolean(payload && typeof payload === 'object' && 'kind' in payload && payload.kind === 'academic_article')
}
